import _find from 'lodash/find'
import _merge from 'lodash/merge'

import Store from '../StoreCollection.js'

let ToDoItemCollection = {}

_merge(ToDoItemCollection, Store, {
  state: {
    apiBaseUrl: '/api/to-do-item/v1'
  }
})

/*
|--------------------------------------------------------------------------
| TODO ITEM CLASS
|--------------------------------------------------------------------------
*/

class ToDoItems {
  static getAttachments(toDoItem) {
    return _find(toDoItem.all_files, f => {
      return f.owning_relationship === 'attachments'
    })
  }
}

/*
|--------------------------------------------------------------------------
| EXPORTS
|--------------------------------------------------------------------------
*/

export default ToDoItemCollection

export { ToDoItemCollection, ToDoItems }
